<template>
    <div class="page-header page-header-mini"></div>
</template>

<script>
    export default {
        name: "PageHeader"
    }
</script>

<style scoped>
    .page-header:before {
        background: white;
    }

    .page-header:after {
        background: white;
    }

    .page-header-mini {
        min-height: 100px !important;
        max-height: 10px;
    }

    @media screen and (max-width: 600px) {
        .page-header-mini {
            min-height: 120px !important;
            max-height: 10px;
        }
    }
</style>